import React from "react";
import "./style.css";

function Parralax({ height }) {
  return (
    <div>
      <div className="container-index">
        <div className="parralax-index" style={{ height }} />
      </div>
    </div>
  );
}

export default Parralax;
